import script from "./OverlayLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./OverlayLoader.vue?vue&type=script&setup=true&lang=js"

import "./OverlayLoader.vue?vue&type=style&index=0&id=f3c7b26a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f3c7b26a"]])

export default __exports__